import { DrawerFilterProvider } from '@hapvida/hapvida-core-components';

import { useAuth } from '@hooks';
import { HomeRouter } from '@flows/private/home/router';
import { OptionalRoutesEnum } from 'routes/enums';

import { BeneficiaryServicesLayout } from './layout';
import { BeneficiaryServicesHeader } from './components/BeneficiaryServicesSubHeader';

export function BeneficiaryServicesPage() {
  const { optionalRoutes } = useAuth();

  const beneficiaryServicesExists =
    optionalRoutes?.[OptionalRoutesEnum.BENEFICIARY_SERVICES];

  if (!beneficiaryServicesExists) {
    window.location.replace(HomeRouter.path);
    return null;
  }

  return (
    <DrawerFilterProvider>
      <BeneficiaryServicesHeader />
      <BeneficiaryServicesLayout />
    </DrawerFilterProvider>
  );
}
